import {_} from 'lodash';
import * as ko from "knockout";
import {IImportHrFile, IMessage, IMessageData} from '../../../index';
import PromiseRequest from "../../../req/PromiseRequest";
import {createErrorMessage} from "../../../util/misc";
import {PLEASE_WAIT_MESSAGE, REQUEST_MESSAGE} from "../../../constants/Language";
import {ISortableTableParams} from "../../sortable/index";
import {nsSearchToggle} from "../../search/nsSearchToggle";
import {getSearchParams} from "../../../util/request";
import {MAX_RESULTS_PER_PAGE} from "../../../constants";
import {lm} from "../../../appContext";
import AllCheckbox = nsSearchToggle.AllCheckbox;
import ItemCheckbox = nsSearchToggle.ItemCheckbox;
import {ButtonManager} from "../../../util/ButtonManager";
import {getCancelButton, getContinueButton} from "../../../constants/RouteDefinitions";
import {IDialogOptionsComponent} from "../../dialog/index";
import {nsRoute} from "../../../util/route";
import ButtonOrder = nsRoute.ButtonOrder;
import send_messages_by_message_flowsHtml from './send-messages-by-message-flows.html?raw';

export let template = send_messages_by_message_flowsHtml;

enum Step {
    NA,
    Form,
    Submit,
    Success,
    Error,
}

interface IParams {
    importHrFileId: number
    dialog: IDialogOptionsComponent
}

export class viewModel {
    private Step = Step;
    private data: KnockoutObservableArray<IMessage> = ko.observableArray<IMessage>([]);
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private req_getimporthrfile: PromiseRequest = new PromiseRequest('getimporthrfile');
    private req_searchmessage: PromiseRequest = new PromiseRequest('searchmessage');
    private reqSubmit: PromiseRequest = new PromiseRequest('sendallmessages');
    private selected: KnockoutObservableArray<IMessage> = ko.observableArray<IMessage>([])
    private sortColumn: KnockoutObservable<keyof IMessage> = ko.observable('name' as keyof IMessage)
    private step: KnockoutObservable<Step> = ko.observable<Step>(Step.NA);
    private readonly pageButtons: ButtonManager = new ButtonManager()

    private tableParams: ISortableTableParams<IMessage> = {
        data: this.data,
        isSelected: (o: IMessage) => {
            return new ItemCheckbox({item: o, key: 'id', selected: this.selected}).isChecked()
        },
        sortcol: this.sortColumn,
        showAll: true,
        allCheckbox: new AllCheckbox<IMessage>({
            data: this.data,
            selected: this.selected,
            key: 'id',
        }),
        route: 'messageflow',
        onRowClick: (o: IMessage) => {
            new ItemCheckbox({item: o, key: 'id', selected: this.selected}).toggle()
            return true
        },
        TABLE: [
            {
                key: 'selector',
            },
            {
                key: 'name',
                sort: true,
                component: obj => ({
                    name: 'component/variable/messagetemplate',
                    params: {item: obj, linkable: true, target: '_blank', noClickBubble: true,}
                }),
            },
            {
                key: 'subject',
                sort: true,
            },
            {
                key: 'recipientfield',
                sort: true,
            },
        ],
    }

    private importHrFileId: number
    private importHrFile!: IImportHrFile

    constructor(private params: IParams) {
        this.importHrFileId = params.importHrFileId

        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.(), {
            validator: () => [Step.NA, Step.Form].includes(this.step()),
        }))
        this.pageButtons.add(getContinueButton({
            label: 'send message|p',
            labelBracketInfo: () => {
                const n = this.selected().length
                return n ? `${n} ${lm.t(`messageflow|ac|n:${n}`)}` : ''
            },
            onClick: () => this.onSubmit(),
            enabled: () => !!this.selected().length,
            order: ButtonOrder.SUBMIT,
            validator: () => this.step() === Step.Form,
        }))
        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.(), {
            icon: 'fa-times',
            label: 'close',
            validator: () => this.step() === Step.Success,
        }))

        this.init();
    }

    private init() {
        this.step(Step.NA);
        this.messageData({message: REQUEST_MESSAGE});
        Promise.resolve()
            .then(() => {
                return this.req_getimporthrfile
                    .request({importfileid: this.importHrFileId})
                    .then((data: [IImportHrFile]) => {
                        this.importHrFile = data[0]
                        if (!this.importHrFile?.synccyclesteps?.length) {
                            throw (lm.t(`[((synchronization cycle))] ((no data))`))
                        }
                    })
            })
            .then(() => {
                return this.req_searchmessage
                    .request(getSearchParams({
                        resultsprpage: MAX_RESULTS_PER_PAGE,
                        sortcol: 'name',
                    }))
                    .then((data: IMessage[]) => {
                        this.data(data.filter((item: IMessage) => !!item.syncstepid && !!item.active));
                        this.messageData(null);
                        this.step(Step.Form);
                    })
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            })
    }

    private onSubmit() {
        this.step(Step.Submit);
        this.messageData({message: PLEASE_WAIT_MESSAGE});
        const historyid = _.last(this.importHrFile.synccyclesteps)?.id
        const messageids = this.selected().map((item: IMessage) => item.id);
        this.reqSubmit.abort();
        this.reqSubmit.request({
            historyid: historyid,
            messageids: messageids.join(','),
        })
            .then((data: null) => {
                this.messageData({message: `message is sent|p`, type: 'success'});
                this.step(Step.Success);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)));
                this.step(Step.Form);
            });
    }

    dispose() {
        this.req_getimporthrfile.abort();
        this.req_searchmessage.abort();
        this.reqSubmit.abort();
    }
}
